import clsx from 'clsx'
import React from 'react'

import { AnalyticsActionType } from 'types/analytics.type'

import styles from './Video.module.scss'
import VideoPlaceholder from '../../assets/videos/our_work_main_banner.png'
import { trackAnalytics } from '../../utils/analytics'
import PlayIcon from '../common/playIcon/PlayIcon'
import VideoModal from '../common/videoModal/VideoModal'

interface Props {
  videoSrc: string
}

export const Video = ({ videoSrc }: Props) => {
  const [play, setPlay] = React.useState(false)
  const [hover, setHover] = React.useState(false)
  const [showModal, setShowModal] = React.useState(false)

  const handlePlayClick = () => {
    setPlay(true)
    setShowModal(true)
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: 'pg_act_ourwork_header_viewvideo',
    })
  }

  return (
    <>
      <div className={styles.container}>
        <div
          className={clsx(styles.videoWrapper, hover && styles.hover)}
          onMouseLeave={() => setHover(false)}
          onMouseEnter={() => setHover(true)}
          onClick={handlePlayClick}
        >
          <img src={VideoPlaceholder} alt="" className={styles.videoPlaceholder} />
          <PlayIcon className={styles.playIcon} />
        </div>
      </div>
      <VideoModal show={showModal} setShow={setShowModal} videoSrc={videoSrc} setPlayVideo={setPlay} playVideo={play} />
    </>
  )
}
